// Translation core: nested-key lookup with {placeholder} interpolation.
// Ported from anyainow's lib/i18n/translate.ts (same key format, so a
// catalog written for one is structurally compatible with the other) — pure
// logic, no Next.js dependency, so it's copied verbatim rather than shared.
// Missing keys fall back to the key itself so a gap shows up on screen
// instead of crashing.

function lookup(dict, key) {
  let node = dict;
  for (const part of key.split(".")) {
    if (typeof node !== "object" || node === null) return undefined;
    node = node[part];
  }
  return typeof node === "string" ? node : undefined;
}

export function interpolate(template, values) {
  if (!values) return template;
  return template.replace(/\{(\w+)\}/g, (match, name) =>
    name in values ? String(values[name]) : match,
  );
}

export function createTranslator(dict) {
  return (key, values) => {
    const template = lookup(dict, key);
    if (template === undefined) {
      if (import.meta.env.DEV) {
        console.warn(`[i18n] missing translation key: ${key}`);
      }
      return key;
    }
    return interpolate(template, values);
  };
}
